import Vue from 'vue'
import router from './router'
import { message } from 'ant-design-vue';
import './global.less'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import App from './App.vue'
import baseUrl from './utils/env';
import moment from 'moment'
import axios from "axios";
import {toPage} from '@/utils/utils'
import store from '@/store/index'
import {notify} from '@/utils/notify'

import "@/mock/api" //开发测试使用mock

message.config({ top: "200px" });
Vue.prototype.$Message = message;
Vue.prototype.$toPage = toPage;
Vue.prototype.$notify = notify;
Vue.prototype.$moment = moment
Vue.prototype.$axios = axios;
Vue.config.productionTip = false
Vue.prototype.$httpUrl = baseUrl;
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')


//防多次点击，重复提交
Vue.directive('preventReClick', {
  inserted(el, binding) {
    el.addEventListener('click', () => {
      if (!el.disabled) {
        el.disabled = true
        setTimeout(() => {
          el.disabled = false
        }, binding.value || 10000)
      }
    })
  }
});

